import loadfonts from './index';

export { loadIcons } from './index';
export default loadfonts;
